






















































































import {
  defineComponent,
  onMounted,
  computed,
  useRouter,
  ref,
  useFetch,
  watch,
} from "@nuxtjs/composition-api";
import { useUiState, useVoucher } from "~/composables";
import { useUser } from "~/modules/customer/composables/useUser";
import { Voucher } from "~/composables/useVoucher/useVoucher";
import VoucherItem from "~/components/vouchers/VoucherItem.vue";
import VoucherDetailModal from "~/components/vouchers/VoucherDetailModal.vue";
import { useVoucherStore } from "~/stores/extensionApi";
import { useUiNotification } from "~/composables";

export default defineComponent({
  name: "CollectVoucher",
  components: {
    VoucherItem,
    VoucherDetailModal,
  },

  setup() {
    const router = useRouter();
    const { user, load: loadUser, isAuthenticated } = useUser();
    const { send: sendNotification } = useUiNotification();
    const {
      load: loadVouchers,
      post: postVoucher,
      vouchers: vouchers,
    } = useVoucher();
    const { toggleLoginModal } = useUiState();
    const customerId = computed(() => user.value?.customer_id);
    const itemsDetail = ref(<Voucher>null);
    const isModalVoucher = ref(false);
    const voucherStore = useVoucherStore();
    const indexActive = ref(0);

    // const ruleIdLocal = computed(() => {
    //   if (process.client) {
    //     return localStorage.getItem(`ruleIdVouchers`);
    //   }
    //   return null;
    // });

    // const ruleId = computed(() => {
    //   return voucherStore.getRuleId || ruleIdLocal.value;
    // });

    // console.log("ruleId: ", ruleId.value);

    const listVoucher = ref<Voucher[]>([]);
    const listVoucherDefault = ref<Voucher[]>([]);

    const lengthListCoupon = computed(() => {
      return listVoucherDefault.value?.length || 0;
    });

    const lengthListCouponOnline = computed(() => {
      return (
        listVoucherDefault.value?.filter(
          (item) => item.voucher_type_apply != "voucher_offline"
        )?.length || 0
      );
    });

    const lengthListCouponOffline = computed(() => {
      return (
        listVoucherDefault.value?.filter(
          (item) => item.voucher_type_apply == "voucher_offline"
        )?.length || 0
      );
    });

    onMounted(async () => {
      const ruleId =
        voucherStore.getRuleId ||
        (process.client ? localStorage.getItem(`ruleIdVouchers`) : null);
      if (!ruleId || ruleId?.length == 0) {
        return;
      }
      const param = customerId.value
        ? `?rule_ids=${ruleId}&customer_id=${customerId.value}`
        : `?rule_ids=${ruleId}`;
      await loadVouchers(param);
      listVoucher.value = vouchers.value || [];
      listVoucherDefault.value = vouchers.value || [];
    });

    const change = (data: Voucher) => {
      itemsDetail.value = data;
      isModalVoucher.value = true;
    };

    const saveVoucher = async (data: Voucher) => {
      if (!isAuthenticated.value) {
        toggleLoginModal();
        return;
      } else {
        itemsDetail.value = data;
        let dataPost = {
          customerId: customerId.value,
          couponCode: data?.counpon_code,
          ruleId: data?.rule_id,
        };
        let response = await postVoucher(dataPost);
        if (response && response?.coupon_code) {
          voucherStore.resetVoucherDataStore();

          sendNotification({
            id: Symbol("save_voucher_success"),
            message: "Lưu mã thành công!",
            type: "success",
            icon: "check",
            persist: false,
            title: "Lưu mã thành công!",
          });

          isModalVoucher.value = false;
          if (itemsDetail.value) {
            itemsDetail.value.is_collect = true;
          }
          // Todo: Logic khác
        }
      }
    };

    watch(
      () => indexActive.value,
      (newVal) => {
        if (newVal == 0) {
          listVoucher.value = listVoucherDefault.value;
        } else if (newVal == 1) {
          listVoucher.value = listVoucherDefault.value?.filter(
            (e) => e.voucher_type_apply != "voucher_offline"
          );
        } else if (newVal == 2) {
          listVoucher.value = listVoucherDefault.value?.filter(
            (e) => e.voucher_type_apply != "voucher_online"
          );
        }
      },
      { immediate: true }
    );

    const voucherCollectData = (vouchers) =>
      vouchers?.filter((e) => e?.voucher_collect) || [];

    return {
      listVoucher,
      isModalVoucher,
      itemsDetail,
      change,
      saveVoucher,
      loadUser,
      user,
      isAuthenticated,
      toggleLoginModal,
      sendNotification,
      lengthListCoupon,
      lengthListCouponOnline,
      lengthListCouponOffline,
      indexActive,
      voucherCollectData,
    };
  },
});
